<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
            <!-- <ion-button>
              <ion-icon slot="icon-only" name="menu"></ion-icon>
            </ion-button> -->
          </ion-menu-toggle>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <bg :opaque="0"></bg>
      <!-- {{ $store.state }} -->
      <ion-grid>
        <headerlogo></headerlogo>
        <ion-row>
          <ion-col size="12">
            <div class="btn-squared-wrapper">
              <ion-button class="btn-squared" @click="$router.push({name: 'profile' });"><img src="../assets/svg/icon-profile.svg"></ion-button>
              <div class="btn-squared-label">Profile</div>
            </div>
            <div class="btn-squared-wrapper">
              <ion-button class="btn-squared" @click="$router.push({name: 'yacht-list' });"><img src="../assets/svg/icon-yachts.svg"></ion-button>
              <div class="btn-squared-label">Yachts list</div>
            </div>
            <div class="btn-squared-wrapper" v-if="$store.state.user_role != 'client'">
              <ion-button class="btn-squared" @click="$router.push({name: 'new-yacht' });"><img src="../assets/svg/icon-plus.svg"></ion-button>
              <div class="btn-squared-label">New yacht</div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
// import axios from "axios"
export default {
  name: "Home",
  data: function() {
    return {}
  },
  methods: {
  },
  mounted: function() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>